export * from './ResidentDiscount';
